import { useContext } from "react";
import { PreOnboardingContext } from "../../contexts/PreOnboardingContext";

export const usePreOnboarding = () => {
  const context = useContext(PreOnboardingContext);
  if (!context) {
    throw new Error(
      "usePreOnboarding must be used within PreOnboardingProvider"
    );
  }
  return context;
};
